var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"seekBarWrapper"},[_c('div',{staticClass:"seekBar"},[_c('div',{staticClass:"fillArea",style:(`width: ${_vm.progress}%`)})])])
}
var staticRenderFns = []

export { render, staticRenderFns }